<template>
  <div class="focused-create card">
    <div class="header-row border-b border-gray-200">
      <span class="text-capitalize">{{view}}</span> Send To Details
      <span v-if="current.name && !loading">
        for <strong >{{ current.name }}</strong>
      </span>
      <span v-show="loading">
        <i class="fa fa-spinner fa-spin"></i>
      </span>
      <a target="_blank" :href="`/view/send-to-types#${sendToDetails.send_to_type}`" class="std-help-link">
        <i class="fa fa-question"></i>
      </a>
    </div>
    <div class="card-body">
      <div class="progress-indicator">
        <span
          v-for="i in totalSteps"
          :class="{
            'step-indicator' : true,
            active: i <= step,
            error: i === 1 && invalids.root.includes('send_to_type')
          }"
          @click="step = i"
        >
          Step <strong>{{i}}</strong>
        </span>
      </div>
      <div class="steps">
        <!-- Step 1: Send To Type -->
        <div class="step-1" v-if="step === 1">
          <div class="form-group">
            <label for="focusedSendToType">Client CRM/ATS</label>
            <select id="focusedSendToType"
                    :class="{
                      'form-control' : true,
                      error: invalids.json.includes('send_to_type')
                    }"
                    :value="sendToDetails.send_to_type"
                    @input="update('send_to_type', $event.target.value)"
            >
              <option v-for="type in sendToTypes" :key="type" :value="type">{{type}}</option>
            </select>
          </div>
        </div>
        <!-- Step 2:  Credential Label -->
        <div class="step-2" v-if="step === 2">
          <div class="form-group">
            <label
              for="focusedCredentialLabel">Credential Label</label>
            <input
              type="text"
              data-form-type="other"
              id="focusedCredentialLabel"
              class="form-control"
              :value="sendToDetails.optional_credential_label"
              @input="update('optional_credential_label', $event.target.value)"
            >
          </div>
        </div>
        <!-- Step 3: Specific Export Settings -->
        <div class="step-3" v-if="step === 3">
          <div v-if="!loading">
            <div v-if="!sendToDetails.send_to_type" style="text-align:center;">
              <br>
              You must complete <strong>Step 1</strong> before continuing
            </div>
            <div v-else-if="Object.keys(rules).length">
              <ebe-generate-ftp v-if="sendToDetails.send_to_type === 'ebe'" />
              <p v-if="$store.state.sendToDetails.current.rules_description"
                 style="margin:20px 0;"
                 v-html="$store.state.sendToDetails.current.rules_description"
              ></p>
              <!-- NON JSON Info -->
              <div class="form-group"
                   v-for="(field, key) in rules"
                   v-if="key !== 'json_info'
                   && ruleShouldShow(field, rules, key, sendToDetails)"
              >
                <label :for="`focused${key}`" :class="{
                error: invalids.root.includes(key)
              }">
                  {{field.label}}
                  <span v-if="ruleIsRequired(field, rules, key, sendToDetails)" class="required"></span>
                </label>
                <master-input
                  :type="field.type || 'text'"
                  class="form-control"
                  :value="sendToDetails[key]"
                  @input="update(key, valueFromEvent($event))"
                  :striped="field.striped"
                  :stacked="field.stacked"
                  :inputs="field.inputs"
                  :lead-table-columns="$store.state.sendToDetails.leadTableColumns"
                >
                  <option
                    v-if="field.options"
                    v-for="(optionSettings, option) in field.options"
                    :value="option"
                  >
                    {{option}}
                  </option>
                </master-input>
                <small v-if="field.description" class="form-text text-muted" v-html="field.description"></small>
              </div>
              <!-- JSON Info -->
              <div class="form-group"
                   v-for="(field, key) in rules.json_info"
                   v-if="rules.json_info && ruleShouldShow(field, rules.json_info, key, jsonInfo)"
              >
                <label :for="`focused${key}`" :class="{
                error: invalids.json.includes(key)
              }">
                  {{field.label}}
                  <span v-if="ruleIsRequired(field, rules.json_info, key, jsonInfo)" class="required"></span>
                </label>
                <master-input
                  :type="field.type || 'text'"
                  class="form-control"
                  :value="jsonInfo[key]"
                  @input="updateJSONInfo(key, valueFromEvent($event))"
                  :inputs="field.inputs"
                  :striped="field.striped"
                  :stacked="field.stacked"
                  :lead-table-columns="$store.state.sendToDetails.leadTableColumns"
                >
                  <option v-if="field.options" value="" disabled selected>Select One</option>
                  <option
                    v-if="field.options"
                    v-for="(optionSettings, option) in field.options"
                    :value="option"
                  >
                    {{option}}
                  </option>
                </master-input>
                <small v-if="field.description" class="form-text text-muted" v-html="field.description"></small>
              </div>
            </div>
            <div v-else="!Object.keys(rules).length" style="text-align:center;">
              <br>
              No further setup needed for {{current.name}}. Save now!
            </div>
          </div>
          
          <h4 v-show="loading" style="text-align:center;">
            <br>
            <i class="fa fa-spinner fa-spin"></i>
          </h4>
        </div>
      </div>
    </div>
    <div style="text-align: right" class="card-footer">
      <button class="btn" @click="step--" v-if="step !== 1">Go Back</button>
      <button class="btn btn-primary" @click="step++" v-if="step < totalSteps">Next Step</button>
      <button
        v-if="step === totalSteps"
        class="btn btn-primary"
        @click="$store.dispatch('sendToDetails/save')"
        :disabled="loading || !sendToDetails.send_to_type || saving"
      >
        Save
        <span v-show="saving">
          <i class="fa fa-spinner fa-spin"></i>
        </span>
      </button>
    </div>
  </div>
</template>
<script>
  import { mapState } from 'vuex'
  import { ruleShouldShow, ruleIsRequired } from '../../lib/helpers'
  import EbeGenerateFtp from '../EbeGenerateFtp'
  export default{
    components:{EbeGenerateFtp},
    props:{
      view: String
    },
    data(){
      return {
        step: 1,
        totalSteps: 3,
      }
    },
    computed:{
      ...mapState('sendToDetails',[
        'sendToTypes',
        'invalids',
        'loading',
        'leadTableColumns',
        'current',
        'saving',
        'companies'
      ]),
      sendToDetails(){
        return this.$store.state.sendToDetails.current.sendToDetails
      },
      rules(){
        return this.$store.state.sendToDetails.current.rules
      },
      jsonInfo(){
        return this.$store.state.sendToDetails.current.jsonData
      },
      companyQuery:{
        get(){
          return this.$store.state.sendToDetails.companyQuery
        },
        set(value){
          this.$store.commit('sendToDetails/SET_COMPANY_QUERY', value)
        }
      }
    },
    methods:{
      valueFromEvent(e){
        return e.target ? e.target.value : e
      },
      update(key, value){
        const sendToDetails = this.sendToDetails;
        sendToDetails[key] = value;
        this.$store.commit('sendToDetails/UPDATE_CURRENT_SEND_TO_DETAILS', sendToDetails)
      },
      updateJSONInfo(key, value){
        this.$store.commit('sendToDetails/UPDATE_CURRENT_JSON_DATA_FOR_KEY', {
          key: key,
          value: value
        })
      },
      ruleIsRequired(fieldSettings, allRules, key, values){
        return ruleIsRequired(fieldSettings, allRules, key, values)
      },
      ruleShouldShow(fieldSettings, allRules, key, values){
        return ruleShouldShow(fieldSettings, allRules, key, values)
      }
    },
    watch:{
      '$store.state.sendToDetails.current.sendToDetails.company_ID':{
        handler(value){
          if(this.$refs.companySearch){
            setTimeout(()=>{
              this.$refs.companySearch.inputValue = value.toString()
            }, 5)
          }
        }
      },
      step(){
        setTimeout(()=>{
          if(this.$store.state.sendToDetails.current.sendToDetails.company_ID && this.$refs.companySearch){
            this.$refs.companySearch.inputValue = this.$store.state.sendToDetails.current.sendToDetails.company_ID.toString()
          }
        }, 5)
      }
    }
  }
</script>

<style lang="scss" scoped>
  .progress-indicator{
    text-align:center;
    position:relative;
    &:after{
      content:"";
      position:absolute;
      top:50%;
      left:50%;
      transform:translate(-50%, -50%);
      width:200px;
      height:1px;
      background:#eee;
      z-index:1;
    }
    .step-indicator{
      z-index: 2;
      display:inline-block;
      background:#eee;
      padding: 5px 10px;
      border-radius: 3px;
      position:relative;
      margin: 7px;
      line-height:1;
      cursor:pointer;
      &.active{
        background:#82bc00;
        color:white;
        &:before{
          content:"";
          position:absolute;
          top:50%;
          right:40px;
          transform:translate(-50%, -50%);
          width:30px;
          height:2px;
          background:#82bc00;
          z-index:1;
        }
      }
      &:first-of-type{
        &:before{
          display:none;
        }
      }
      &.error{
        background: #dc3545;
      }
    }
  }
  .required{
    color:#dc3545;
    font-size:1.3em;
    &:after{
      content:"*";
    }
  }
  label.error{
    color: #dc3545;
  }
</style>
